import { Card, CardContent } from "../ui/card";
import { Link } from "react-router-dom";

export default function StatCard({ title, value, icon: Icon, tone = "primary", helper, to }) {
  const toneClass = tone === "warning" ? "bg-amber-50 text-amber-700" : tone === "success" ? "bg-emerald-50 text-emerald-700" : "bg-hospital-primary-light text-hospital-primary";
  const content = (
    <Card className={`metric-card card-hover ${to ? "cursor-pointer hover:border-hospital-primary hover:shadow-md" : ""}`}>
      <CardContent className="pt-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="metric-label">{title}</p>
            <p className="metric-value mt-2">{value}</p>
            {helper && <p className="mt-2 text-sm text-hospital-text-muted">{helper}</p>}
            {to && <p className="mt-3 text-sm font-medium text-hospital-primary">Open details</p>}
          </div>
          {Icon && (
            <div className={`h-11 w-11 rounded-lg flex items-center justify-center ${toneClass}`}>
              <Icon className="h-5 w-5" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );

  if (to) {
    return (
      <Link to={to} className="block rounded-lg focus:outline-none focus:ring-2 focus:ring-hospital-primary/40">
        {content}
      </Link>
    );
  }

  return content;
}
